import { useEffect } from "react";
import ForgotUserName from "../preAuth/forgot-username";
import ForgotUserNameOTP from "../preAuth/forgotusername-otp";
import { useTranslation } from "react-i18next";

export default function ForgotUserNameMain({
  currentStep,
  setCurrentStep,
  data,
  setData,
}) {

  useEffect(() => {
   setCurrentStep(0)
  }, []);

  const { t } = useTranslation();
  const steps = [
    {
      title: t("common.details", {
        defaultValue: "Details",
      }),
    },
    {
      title: t("common.verify_pin", {
        defaultValue: "Verify PIN",
      }),
    },
    {
      title: t("common.complete", {
        defaultValue: "Complete",
      }),
    },
  ];

  return (
    <>
      <div>
        {/* <Stepper
          currentStep={currentStep}
          items={steps}
          setCurrentStep={setCurrentStep}
        ></Stepper> */}
        <div>
          {/* <h5 className="mb-2 " align="left">
            {t("pages.login.forgot_username", {
              defaultValue: "Forgot Username",
            })}
          </h5> */}
          <p
            style={{ fontSize: "14px" }}
            align="left"
            className="secondary_txt_color_two"
          >
           Retrieve your current Username via Email or Mobile Number with our Forgot Username feature.
          </p>
        </div>
        {currentStep === 0 && (
          <ForgotUserName
            data={data}
            setData={setData}
            setCurrentStep={setCurrentStep}
          />
        )}
        {currentStep === 1 && (
          <ForgotUserNameOTP
            data={data}
            setData={setData}
            setCurrentStep={setCurrentStep}
          />
        )}
      </div>
    </>
  );
}
